import React, { Component } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import Footer from 'components/AppFooter/AppFooter'

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { populatedDataToJS, isLoaded, dataToJS } = helpers;

import ContentHeader from 'components/ContentHeader';
import Button from 'components/Button';
import Input from 'components/Input';

import CustomerPanel from 'components/CustomerPanel';
import CustomerList from 'components/CustomerList';

import Loader from 'components/Loader/Loader';


import { keyedObjToArr, formatAddress } from '../../util';

import { Customer } from 'models';

class Customers extends Component {

	constructor (props) {
		super(props);

        this.state = {
            filterBy: ''
        };
	}

	getProductsForCustomer (customer) {
		let products = [];

		if(!customer.orders || !this.props.orders) {
			return products;
		}

		let orderIds = Object.keys(customer.orders);

		if(orderIds && typeof(orderIds) === 'string') {
			orderIds = [orderIds];
		}

		if (orderIds) {
			orderIds.forEach( (orderId)=> {
				let orderProducts = keyedObjToArr(this.props.orders[orderId].products);
				products = products.concat(orderProducts);
			});
		}
		return products;
	}

	createCustomer () {
		let customer = {
			contactInfo : {},
			contactAddress : {}
		};

		this.props.openDrawer(
			<CustomerPanel
				title="Create New Customer"
				customer={customer}
				addCustomer={this.addCustomer.bind(this)}
				getProductsForCustomer={this.getProductsForCustomer.bind(this)}
				addUserToCustomer={this.addUserToCustomer.bind(this)}
				removeUserFromCustomer={this.removeUserFromCustomer.bind(this)}
			/>);
	}

	editCustomer (customer) {

		if(!customer.contactInfo) {
			customer.contactInfo = {};
		}

		if(!customer.contactAddress) {
			customer.contactAddress = {};
		}

		this.props.openDrawer(
			<CustomerPanel
				title={'Editing ' + customer.name}
				editing={true}
				customer={customer}
				getProductsForCustomer={this.getProductsForCustomer.bind(this)}
				saveCustomer={this.saveCustomer.bind(this)}
				addUserToCustomer={this.addUserToCustomer.bind(this)}
				removeUserFromCustomer={this.removeUserFromCustomer.bind(this)}
			/>);
	}

	// Firebase Methods

	addCustomer (customer) {
		//TODO validate customer before adding
		const { firebase } = this.props;
		firebase.push('/customers', customer);
	}

	saveCustomer (customer) {
		const { firebase } = this.props;
		firebase.set(`/customers/${customer.id}`, customer);
	}

	deleteCustomer (customer) {
		this.props.openModal(null, {
			message : 'Are your sure you want to delete this customer?',
			title : 'Delete Customer',
			onClose : (result) => {

				if (result === true) {
					const { firebase } = this.props;

					// Remove the orders for this customer
                    keyedObjToArr(customer.orders).forEach( (order) => {
                       firebase.remove(`/orders/${order.id}`);
                    });

					firebase.remove(`/customers/${customer.id}`);
					//remove schools for customer
					keyedObjToArr(this.props.schools).forEach( (school)=> {
						if(school.customer === customer.id) {
							//remove classrooms for school
							keyedObjToArr(this.props.classrooms).forEach( (classroom)=> {
								if(classroom.school === school.id) {
									//remove classroom from teacher
									keyedObjToArr(this.props.users).forEach( (user)=> {
										if(user.classrooms) {
											firebase.remove(`/users/${user.id}/classrooms/${classroom.id}`);
										}
										if(user.customer === customer.id) {
											firebase.remove(`/users/${user.id}/customer`);
										}
									});
									firebase.remove(`/classrooms/${classroom.id}`);
								}
							});
							firebase.remove(`/schools/${school.id}`);
						}
					});
				}
			}
		});
	}

	addUserToCustomer (userId, customer) {
		if(!customer.id) {
			return;
		}
		const { firebase } = this.props;
		let customerUsers = customer.users;
		customerUsers[userId] = true;
		//firebase.set(`customers/${customer.id}/users/${userId}`, true);
		firebase.set(`customers/${customer.id}/users`, customerUsers);
		firebase.set(`users/${userId}/customer`,customer.id);
	}

	removeUserFromCustomer(userId, customer) {
		if(!customer.id) {
			return;
		}
		const { firebase } = this.props;
		let customerUsers = customer.users;
		delete customerUsers[userId];

		firebase.set(`customers/${customer.id}/users`, customerUsers);
		firebase.remove(`users/${userId}/customer`);
	}

    filterChanged(event){
        this.setState({
            filterBy: event.target.value
        });
    }

	render () {

		if( !isLoaded(this.props.customers) ||
				!isLoaded(this.props.orders) ||
				!isLoaded(this.props.schools) ||
				!isLoaded(this.props.classrooms) ||
				!isLoaded(this.props.users)
			) {
			return (
				<div className="main-content-area" key="customers">
					<div className="page-content">
						<div className="container">
							<Loader color="main" size="large" />
						</div>
					</div>
				</div>
			);
		}

		let button = (<Button
			label="Create Customer"
			onClick={this.createCustomer.bind(this)}
		/>);

        let filter = (<Input
			placeholder="Search"
			inputClass="filter-box"
			value={this.state.filterBy}
			onChange={this.filterChanged.bind(this)}
		/>)

		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
	      transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
			<div className="main-content-area" key="customers">
				<ContentHeader
					filter={filter}
					title="Customers"
					button={button}
				/>
				<div className="page-content">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="main-list-area">
									<CustomerList
										filterBy={this.state.filterBy}
										orders={this.props.orders}
										customers={this.props.customers}
										getProductsForCustomer={this.getProductsForCustomer.bind(this)}
										editCustomer={this.editCustomer.bind(this)}
										deleteCustomer={this.deleteCustomer.bind(this)}
									/>
								</div>
							</div>
						</div>
					</div>
					<Footer/>
				</div>
			</div>
			</ReactCSSTransitionGroup>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		openModal : (modal, props) => { dispatch(openModal(modal, props)); }
	};
};


const populates = { child: 'schools', root: 'schools', keyProp: 'key' };

const fbWrappedComponent = firebaseConnect([
	{ path: '/customers', populates },
	//'/customers',
	'/orders',
	'/schools',
	'/classrooms',
	'/users'
])(Customers);

export default connect(
	({ firebase }) => ({
		//not working but whatever
		customers: populatedDataToJS(firebase, '/customers', populates),
		//customers: dataToJS(firebase, 'customers'),
		orders: dataToJS(firebase, 'orders'),
		schools: dataToJS(firebase, 'schools'),
		classrooms: dataToJS(firebase, 'classrooms'),
		users: dataToJS(firebase, 'users')
	}),
	mapDispatchToProps
)(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/containers/Customers/Customers.js